import { IComponentOptions, IController, IQService } from 'angular';

const templateHtml = require('./esignature-request-sign-modal.component.html');

export class BdEsignatureRequestSignModalComponent implements IComponentOptions {
    public bindings = {
        esignatureIframeUrl: '<',
        helpLink: '<?',
        visible: '=',
        requestSigned: '&',
        clientConfigApiFunc: '<'
    };
    public controller = EsignatureRequestSignModalController;
    public controllerAs = 'vm';
    public template = templateHtml;
}
interface ClientConfig {
    ClientId: string;
    TestMode: boolean;
}

class EsignatureRequestSignModalController implements IController {
    esignatureIframeUrl: string;
    visible: boolean;
    public helloSignEvent: string;
    requestSigned: () => void;
    clientConfigApiFunc: () => Promise<ClientConfig>;
    static $inject: string[] = [
        '$q',
        'HELLOSIGN_CLIENT_EVENT'
    ];

    constructor(
        private $q: IQService,
        private HELLOSIGN_CLIENT_EVENT
    ) {

    }

    $onInit(): void {
        this.helloSignEvent = this.HELLOSIGN_CLIENT_EVENT.Sign;
    }

    public onRequestSigned(): void {
        this.visible = false;
        this.requestSigned();
    }

    close() {
        this.visible = false;
    }

    save() {
        this.visible = false;
        return this.$q.resolve();
    }
}
